import apiClient from '@/api/client';

export interface ConversionStats {
  total: number;
  byGoal: Record<string, number>;
  byStatus: {
    tracked: number;
    googleAdsQueued: number;
    googleAdsUploaded: number;
    googleAdsFailed: number;
  };
  recentConversions: Array<{
    conversionId: string;
    merchantId: string;
    goal: string;
    timestamp: string;
    matomoSuccess: boolean;
    googleAdsStatus?: 'queued' | 'uploaded' | 'failed';
    hasClickId: boolean;
  }>;
  queueStats: {
    messagesVisible: number;
    messagesInFlight: number;
    dlqMessages: number;
  };
  funnel: {
    demoRequested: number;
    registrationCompleted: number;
    profileCompleted: number;
    offerCreated: number;
    offerPublished: number;
    firstQrRedeemed: number;
    active30Days: number;
  };
}

export const ConversionService = {
  async getStats(days = 7, limit = 50): Promise<ConversionStats> {
    const res = await apiClient.get('/conversions', { params: { days, limit } });
    return res.data;
  },
};
